import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'heading-2xl md:heading-3xl mb-3 font-medium md:font-medium',
    description: 'text-s leading-[120%] font-[300]',
    drawer: 'max-md:px-4 max-md:py-8',
    success: 'flex h-full flex-col justify-center',
    button: 'mt-12 w-full max-w-[300px] md:mt-16'
  }
});
